// src/locales/en/dashboard.js
export const dashboard = {
    welcomeBack: "மீண்டும் வருக, {{name}}! 👋",
    businessOverview: "இன்று உங்கள் வணிகத்தில் என்ன நடக்கிறது என்பது இங்கே.",
    totalOrders: "மொத்த ஆர்டர்கள்",
    products: "தயாரிப்புகள்",
    revenue: "வருமானம்",
    customers: "வாடிக்கையாளர்கள்",
    salesUp: "இந்த வாரம் விற்பனை 12% அதிகரித்துள்ளது",
    recentActivity: "சமீபத்திய செயல்பாடு",
    quickActions: "விரைவு செயல்கள்",
    accountInfo: "கணக்கு தகவல்",
    businessName: "வணிக பெயர்",
    yourRole: "உங்கள் பங்கு",
    memberSince: "உறுப்பினராக உள்ள காலம்",
    permissions: "அனுமதிகள்",
    permissionsCount: "{{count}} அனுமதிகள் வழங்கப்பட்டுள்ளன",
    fromLastMonth: "கடந்த மாதத்திலிருந்து",

    // Quick Actions - MISSING
  orderList: "Order பட்டியல்",
  productList: "Product பட்டியல்",
  newBatch: "புதிய Packing Batch",
  dispatchOrders: "Orders Dispatch செய்",
  
  // Key Metrics - MISSING SECTION
  keyMetrics: "முக்கிய Metrics",
  todaysSales: "இன்றைய விற்பனை",
  thisWeek: "இந்த வாரம்",
  thisMonth: "இந்த மாதம்",
  avgOrderValue: "சராசரி Order மதிப்பு",
  orders: "Orders",
  vsLastWeek: "கடந்த வாரத்துடன் ஒப்பிடும்போது",
  vsLastMonth: "கடந்த மாதத்துடன் ஒப்பிடும்போது",
  vsYesterday: "நேற்றுடன் ஒப்பிடும்போது",
  todayVsYesterday: "இன்று vs நேற்று",
  vsLastWeekSameDays: "கடந்த வாரம் இதுவரை உடன் ஒப்பிடும்போது",
  vsLastMonthSameDays: "கடந்த மாதம் இதுவரை உடன் ஒப்பிடும்போது",
  weekToDateVsLastWeek: "இந்த வாரம் vs கடந்த வாரம் இதுவரை",
  weekToDateVsFullLastWeek: "இந்த வாரம் vs முழு கடந்த வாரம்",
  monthToDateVsLastMonth: "இந்த மாதம் vs கடந்த மாதம் இதுவரை",
  monthToDateVsFullLastMonth: "இந்த மாதம் vs முழு கடந்த மாதம்",
  salesValue: "விற்பனை மதிப்பு",
  
  // Order Status Distribution - MISSING SECTION
  ordersByStatus: "Status படி Orders",
  statusDistribution: "Status பகிர்வு",
  totalOrderValue: "மொத்த Order மதிப்பு",
  orderCount: "Order எண்ணிக்கை",
  orderValue: "Order மதிப்பு",
  barChart: "Bar Chart",
  
  // Sales Trend - MISSING SECTION
  salesTrend: "விற்பனை போக்கு",
  salesValue: "விற்பனை மதிப்பு",
  orderQuantity: "Order அளவு",
  last7Days: "கடந்த 7 நாட்கள்",
  last14Days: "கடந்த 14 நாட்கள்",
  last30Days: "கடந்த 30 நாட்கள்",
  
  // Top Products - MISSING SECTION
  topProducts: "அதிகம் விற்பனையான தயாரிப்புகள்",
  product: "தயாரிப்பு",
  quantitySold: "விற்கப்பட்ட அளவு",
  revenueGenerated: "வருமானம்",
  
  // Filters - MISSING SECTION
  allShops: "அனைத்து Shops",
  selectShop: "Shop தேர்ந்தெடு",
  dateRange: "தேதி வரம்பு",
  today: "இன்று",
  yesterday: "நேற்று",
  thisWeekLabel: "இந்த வாரம்",
  lastWeek: "கடந்த வாரம்",
  thisMonthLabel: "இந்த மாதம்",
  lastMonth: "கடந்த மாதம்",
  customRange: "Custom வரம்பு",
  applyFilters: "Filters பயன்படுத்து",
  
  // Loading & Errors - MISSING SECTION
  loading: "Loading...",
  loadingData: "Dashboard data load ஆகிறது...",
  errorLoading: "Data load செய்வதில் பிழை",
  noData: "Data இல்லை",
  tryAgain: "மீண்டும் முயற்சிக்கவும்",
  
  // Empty States - MISSING SECTION
  noOrdersFound: "Orders கிடைக்கவில்லை",
  noProductsFound: "தயாரிப்புகள் கிடைக்கவில்லை",
  noDataForPeriod: "தேர்ந்தெடுக்கப்பட்ட காலத்திற்கு data இல்லை",
  
  // Work Queue - MISSING SECTION
  workQueue: "Work Queue",
  assigned: "ஒதுக்கப்பட்டது",
  allOrders: "அனைத்து Orders",
  viewAll: "அனைத்தையும் பார்",
  noOrdersInQueue: "Queue-இல் orders இல்லை",
  myWorkQueue: "எனது Work Queue",
  
  // Inventory Alerts - MISSING SECTION
  inventoryAlerts: "Inventory Alerts",
  allWarehouses: "அனைத்து Warehouses",
  threshold: "Threshold",
  lowStockItems: "குறைந்த Stock Items",
  outOfStockItems: "Stock இல்லாத Items",
  lowStock: "குறைந்த Stock",
  outOfStock: "Stock இல்லை",
  noInventoryAlerts: "அனைத்து inventory levels ஆரோக்கியமாக உள்ளன",
  
  // Packing Activity - MISSING SECTION
  packingActivity: "Packing Activity",
  todayBatches: "இன்றைய Batches",
  readyToPack: "Packing செய்ய தயார்",
  inPacking: "Packing-இல் உள்ளது",
  dispatchedToday: "இன்று Dispatch செய்யப்பட்டது",
  courierBreakdown: "Courier Breakdown",
  
  // Courier Returns - MISSING SECTION
  courierReturns: "Courier Returns",
  returns: "Returns",
  noReturns: "இந்த காலத்திற்கு returns இல்லை",
}